export default __webpack_public_path__ + "static/media/redeem-bonus2-m-1.b72c5751.webp";